module.exports = __webpack_public_path__ + "f76d7efd6bda7494cbd35d2122533b66.svg";